import * as React from 'react';
import {Icon, view} from '@sail/ui';
import {warning} from '@sail/icons/react/Icon';
import type {ContentStateProps, ContentStateSize} from './ContentState';
import {ContentState} from './ContentState';

type Props = Omit<ContentStateProps, 'icon'> & {
  showIcon?: boolean;
};

const getIconSize = (size: ContentStateSize) => {
  switch (size) {
    case 'small':
      return 'xsmall';
    case 'medium':
      return 'large';
    default:
      return 'medium';
  }
};

export const ErrorState = ({size = 'medium', showIcon, ...rest}: Props) => {
  return (
    <ContentState
      {...rest}
      size={size}
      icon={
        !showIcon && (
          <view.div
            css={{
              padding: size === 'large' ? 'space.150' : 'space.0',
              backgroundColor: size === 'large' ? 'surface' : 'transparent',
              width: 'min',
              height: 'min',
              borderRadius: 'small',
              boxShadow: size === 'large' ? 'hover' : 'none',
            }}
          >
            <Icon
              icon={warning}
              size={getIconSize(size)}
              css={{
                marginBottom: 'space.0',
                color: 'subdued',
                stack: 'y',
                alignY: 'center',
              }}
            />
          </view.div>
        )
      }
    />
  );
};
